<template>
  <div>
    <img v-if="imageUrl !== null" :src="imageUrl" style="max-width: 150px;" />

    <b-form-file
      v-model="modelValue"
      placeholder="Pilih file atau letakkan di sini..."
      drop-placeholder="Drop file here..."
      @change="changeImage($event)"
    />
    <small class="text-danger">{{ errors[0] }}</small>
  </div>
</template>

<script>
import { BFormFile } from "bootstrap-vue";
export default {
  data() {
    return {
      imageUrl: null,
    };
  },
  components: {
    BFormFile,
  },
  props: {
    value: {
      type: "",
    },
    errors: {
      type: "",
    },
  },
  computed: {
    modelValue: {
      get: function () {
        return this.value;
      },
      set: function (data) {
        this.$emit("value", data);
      },
    },
  },
  methods: {
    changeImage(event) {
      this.value = event.target.files[0];
      this.showImage(event.target.files[0]);
    },
    showImage(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.imageUrl = e.target.result;
      };

      reader.readAsDataURL(file);
    },
  },
};
</script>
